import React, { useState, useEffect } from "react";
import {
  Autocomplete,
  Button,
  TextField,
  Grid,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import SaveIcon from "@mui/icons-material/Save";
import UpdateIcon from "@mui/icons-material/Update";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import AlertDialog from "../../AlertDialog/AlertDialog";
import CardHeadMenu from "../CardHeadMenu/CardHeadMenu";
import configServ from "../../../services/config";

//FUNCTION
const BatchCard = ({ isChanged, setIsChanged, editData, setEditData }) => {
  //#region code
  const app = useSelector((state) => state.GlobalVariables.noRoomService);
  const { company_id, user_id } = useSelector((state) => state.GlobalVariables);
  const [formData, setFormData] = useState({
    status: true,
  });
  const [isEdit, setIsEdit] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState("");
  const [isCreate, setIsCreate] = useState(false);

  const handleOpenDialog = (content) => {
    setDialogContent(content);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setDialogContent("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((state) => ({
      ...state,
      [name]: value,
    }));
  };

  const handleChangeCheckbox = (e) => {
    const { name, checked } = e.target;
    setFormData((state) => ({
      ...state,
      [name]: checked,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const error = handleFormValidation();
    if (error === false) {
      return false;
    }
    setValidationErrors({});

    const dataToSend = {
      ...formData,
      company_id: company_id,
      admin_id: user_id,
    };
    try {
      if (!isEdit) {
        const res = await configServ.createBatch(dataToSend);
        if (res.status === 200) {
          setIsChanged(!isChanged);
          handleOpenDialog(res.message);
        } else {
          handleOpenDialog(res.message || "An error occurred.");
        }
        clear();
      } else {
        const res = await configServ.updateBatch(dataToSend);
        if (res.status === 200) {
          setIsChanged(!isChanged);
          handleOpenDialog(res.message);
        } else {
          handleOpenDialog(res.message || "An error occurred.");
        }
        clear();
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    if (editData && Object.keys(editData).length > 0) {
      setFormData(editData);
      setIsEdit(true);
      setIsCreate(true);
    }
  }, [editData]);

  const clear = () => {
    setFormData({
      status: true,
    });
    setValidationErrors({});
    setIsEdit(false);
    setEditData({});
  };

  const handleFormValidation = () => {
    const errors = {};
    if (!formData.batch_name) {
      errors.batch_name = "required";
    }

    setValidationErrors(errors);
    return Object.values(errors).every((error) => error === "");
  };

  const handlePopup = () => {
    setIsCreate(!isCreate);
  };
  //#endregion

  return (
    <>
      <AlertDialog
        open={dialogOpen}
        setOpen={handleCloseDialog}
        title="Alert"
        message={dialogContent}
        buttonTitle="Ok"
      />

      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"BATCH"}
        handlePopup={handlePopup}
        isEdit={isEdit}
        create={isCreate}
      />

      {isCreate && (
        <motion.div
          style={{
            width: "100%",
            backgroundColor: "#e3f3fc",
            paddingTop: 10,
            paddingBottom: 10,
            paddingLeft: 20,
            paddingRight: 20,
            borderRadius: "10px",
            border: "none",
          }}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.1, delay: 0.1 }}
        >
          <form onSubmit={handleSubmit}>
            <Grid
              container
              alignItems="flex-end"
              justifyContent="flex-start"
              spacing={1}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} md={12} justifyContent={"flex-start"}>
                  <Typography sx={{ fontSize: "16px", fontWeight: "bolder" }}>
                    Batch Detail
                  </Typography>
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                  <TextField
                    id="batch_name"
                    name="batch_name"
                    label="Batch Name*"
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={{ backgroundColor: "white" }}
                    value={formData.batch_name || ""}
                    onChange={handleChange}
                    error={!!validationErrors.batch_name}
                  />
                </Grid>

                {/* <Grid item xs={12} md={4}>
                                    <TextField
                                        id="description"
                                        name="description"
                                        label="Description"
                                        variant="outlined"
                                        size='small'
                                        fullWidth
                                        sx={{ backgroundColor: 'white' }}
                                        value={formData.description || ''}
                                        onChange={handleChange}
                                    />
                                </Grid> */}

                <Grid item xs={12} md={4}>
                  <FormGroup sx={{ display: "flex", flexDirection: "row" }}>
                    <FormControlLabel
                      name="status"
                      control={
                        <Checkbox checked={Boolean(formData.status) || false} />
                      }
                      onChange={handleChangeCheckbox}
                      label="Status"
                      style={{ marginRight: "20px" }}
                    />
                  </FormGroup>
                </Grid>
              </Grid>
            </Grid>

            <Grid container spacing={2} justifyContent="space-between" px={2}>
              <Grid
                item
                container
                justifyContent="flex-end"
                alignItems="center"
                spacing={2}
              >
                <Grid item>
                  <Button
                    onClick={clear}
                    variant="contained"
                    color="secondary"
                    startIcon={<RotateLeftIcon />}
                  >
                    Reset
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    type="submit"
                    //onClick={handleSubmit}
                    variant="contained"
                    color={isEdit ? "success" : "primary"}
                    startIcon={isEdit ? <UpdateIcon /> : <SaveIcon />}
                  >
                    {isEdit ? "Update" : "Save"}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </motion.div>
      )}
    </>
  );
};

export default BatchCard;
